/**
 * Landing pages that own the viewport, with the app header, promo banner and
 * standard footer suppressed.
 */
export enum ImmersiveLandingPage {
  DishStories = 'DISH_STORIES',
  FullBleedVideo = 'FULL_BLEED_VIDEO',
  HowItWorks = 'HOW_IT_WORKS',
}
